import type { OrganizationalUnitMember as OrganizationalUnitMemberModel } from '@/adapters/catalogv1.g';

export function extractOrganizationalUnitMember(
  model: OrganizationalUnitMemberModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ouRef: model.ou_ref ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogOrganizationalUnitMember = ReturnType<
  typeof extractOrganizationalUnitMember
>;
